import { requireLoggedInUser } from '@/Router';
import { createFileRoute } from '@tanstack/react-router';

/**
 * The routes under this folder are to be used for testing purposes only.
 * They are not meant to be used in production.
 *
 * Please do not use them in production.
 */

export const Route = createFileRoute('/test')({
  beforeLoad() {
    requireLoggedInUser();
  }
});